import apiHandler from "../core/apiHandler";

/**
 * 🔓 QZ Tray Public Certificate API
 *
 * API base para consumir el certificado público activo (cert.pem)
 * utilizado para inicializar la conexión segura con QZ Tray.
 *
 * ✅ Endpoint:
 * - GET /api/qztray/certificates/public
 */
const qzTrayPublicCertificateApi = apiHandler("qztray/certificates/public");

export default qzTrayPublicCertificateApi;
